import {
  ENDPOINT_CREATE_LOAN_APPLICATION,
  ENDPOINT_IFP_CREATE_APPLICATION,
  IfpCreateApplicationRequest,
  IfpCreateApplicationResponse,
  SecLoansCreateApplicationRequest,
  SecLoansCreateApplicationResponse,
} from '@shared/sec-loans'
import { callEndpoint } from '@ui-common/utils'

export const createLoanApplication = (
  requestPayload: SecLoansCreateApplicationRequest,
): Promise<SecLoansCreateApplicationResponse> =>
  callEndpoint(ENDPOINT_CREATE_LOAN_APPLICATION, {
    requestPayload,
  })

export const createIfpApplication = (
  requestPayload: IfpCreateApplicationRequest,
): Promise<IfpCreateApplicationResponse> =>
  callEndpoint(ENDPOINT_IFP_CREATE_APPLICATION, {
    requestPayload,
  })
